import styled from "styled-components"
import GLOBAL from "../../global"

export const Container = styled.div`
  transition: all .7;
  scroll-behavior: smooth;
  text-align : center;
  width : 100%;
  padding : 10px 0 10px;
  transition : all .7s;
  position : absolute;
  bottom : -38px;
  background : #fff;
  z-index : 1;
  overflow: hidden;
  
  align-items : center;
  justify-content : center;
  box-shadow: 1px 1px 2px #000;
  -webkit-box-shadow: -1px 1px 12px rgba(0,0,0,.3);

  display: block;

  
  
  @media(max-width: 800px) {
    display : block;
    padding : 10px 0 10px;    
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;  

    ::-webkit-scrollbar {
      width: 0px !important;
     background: transparent !important; 
    }
    
    ::-webkit-scrollbar { display:none !important }
  }

  

  

/* ::-webkit-scrollbar-track {  
  box-shadow: inset 0 0 5px silver !important;
  border-radius: 0px !important;
}


::-webkit-scrollbar-thumb {
  background: #051629!important;
  border-radius: 0px !important;
}


::-webkit-scrollbar-thumb:hover {
  background: #051629 !important;
}

::-webkit-scrollbar{
  height: 8px;
  display: block;
} */

.zeraLink, .zeraLink:hover, .zeraLink:focus{
  text-decoration: none;
  color: #000;
}

`

export const Item = styled.span`
 
  overflow-wrap: normal;
  margin-right : 30px;  

  
  white-space: nowrap;
  border-radius: 10px ;
  padding: 0px 8px;
  cursor : pointer;
  transition : all 1s;
  ${({ selected }) => {
    if (selected) {
      return `
        background : ${GLOBAL.COLORS.primary};
        color : #fff;
        `
    }
  }} 
  /* border-radius : 10px;
  height: 60px;
  transition : all 1s;
  padding : 12px;
  background : #fff;
  justify-content : center;
  display : flex;
  align-items : center;
  margin-right : 10px;
  box-shadow: 1px 1px 2px #000;
    -webkit-box-shadow: -1px 1px 12px rgba(0,0,0,.3);
  
  cursor : pointer;


  */

`